import { useaxios } from "../../../utils/useaxios";
export default (company_id) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/company_loan/company_loan.php', { company_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setcompany_loan_report', payload: res.data });
            settable_type("company_loan_report");
        }
        // setloading(false);
    });
}